const i18n_fields = {
  EN: [
    { key: 'apply_at', label: 'Date', sortable: false, thStyle: 'width: 5%' },
    { key: 'servicename', label: 'Service', sortable: false },
    { key: 'price', label: 'Price(A)', sortable: false  },
    { key: 'usage', label: 'Usage(B)', sortable: false  },
    { key: 'base_price', label: 'Amount(A*B)', sortable: false  },
    { key: 'discount_price', label: 'Discount(C)', sortable: false  },
    { key: 'total_price', label: 'Charge(A*B - C)', sortable: false  },
    { key: 'is_paid', label: 'Status', sortable: false  },
    { key: 'description', label: 'Info', sortable: false },
  ],
  KO : [
    { key: 'apply_at', label: '날짜', sortable: false, thStyle: 'width: 5%' },
    { key: 'servicename', label: '서비스', sortable: false },
    { key: 'price', label: '가격(A)', sortable: false  },
    { key: 'usage', label: '사용량(B)', sortable: false  },
    { key: 'base_price', label: '기본가격(A*B)', sortable: false  },
    { key: 'discount_price', label: '할인율(C)', sortable: false  },
    { key: 'total_price', label: '가격(A*B - C)', sortable: false  },
    { key: 'is_paid', label: '상태', sortable: false  },
    { key: 'description', label: '정보', sortable: false },
  ],
  JP: [
    { key: 'apply_at', label: '日付', sortable: false, thStyle: 'width: 5%' },
    { key: 'servicename', label: 'Service', sortable: false },
    { key: 'price', label: 'Price(A)', sortable: false  },
    { key: 'usage', label: 'Usage(B)', sortable: false  },
    { key: 'base_price', label: 'Amount(A*B)', sortable: false  },
    { key: 'discount_price', label: 'Discount(C)', sortable: false  },
    { key: 'total_price', label: 'Charge(A*B - C)', sortable: false  },
    { key: 'is_paid', label: 'Status', sortable: false  },
    { key: 'description', label: 'Info', sortable: false },
  ]
}

const _i18n_error = {
  modal_history : {
    EN: `no have more information`,
    KO: `no have more information`,
    JP: `これ以上の情報はありません`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_error
}

export default _i18n_data